"use client";

type ItemPayload = { itemNo?: string; itemId: string | number };

declare global {
    interface Window {
        __BASE_URL?: string;
    }
}

const ENDPOINT =
    (typeof window !== "undefined" && window.__BASE_URL)
        ? `${window.__BASE_URL}/module/dcshop/b2c/ajax.php?function=getDataLayerForAlgolia`
        : `/module/dcshop/b2c/ajax.php?function=getDataLayerForAlgolia`;

function collectItems(): ItemPayload[] {
    const nodes = document.querySelectorAll<HTMLElement>("[data-item-id]");
    const items: ItemPayload[] = [];
    nodes.forEach((el) => {
        const itemId = el.dataset.itemId;
        if (!itemId) return;
        const itemNo = el.dataset.itemNo;
        items.push({ itemId, itemNo });
    });
    return items;
}

function injectResponse(resp: any) {
    if (resp?.script) {
        new Function(resp.script)();
    }
    if (resp?.tag) {
        let holder = document.querySelector(".tagManagerDiv") as HTMLElement | null;
        if (!holder) {
            holder = document.createElement("div");
            holder.className = "tagManagerDiv";
            holder.style.display = "none";
            document.body.appendChild(holder);
        }
        holder.innerHTML = resp.tag;

        holder.querySelectorAll("script").forEach((old) => {
            const s = document.createElement("script");
            [...old.attributes].forEach((a) => s.setAttribute(a.name, a.value));
            s.text = (old as HTMLScriptElement).text;
            old.replaceWith(s);
        });
    }
}

export async function algoliaListUpdate() {
    if (typeof window === "undefined") return;

    const itemArray = collectItems();
    if (!itemArray.length) return;

    const payload = {
        itemArray,
        currentURL: window.location.pathname,
    };

    try {
        const res = await fetch(ENDPOINT, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            credentials: "same-origin",
            body: JSON.stringify(payload),
        });

        const text = await res.text();
        let data: any;
        try { data = JSON.parse(text); } catch { data = { raw: text }; }

        injectResponse(data);
    } catch {
    }
}
